module.exports = __webpack_public_path__ + "static/media/blog-2.911c4ba7.svg";